/**
 *
 * Points
 *
 */

import { mapGetters } from 'vuex';

export default {
  name: 'PointsLog',

  computed: {
    ...mapGetters('Points', {
      mg_pointsLogs: 'pointsLogs',
    }),
  },
};
